var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCardYuflyma(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 243 153",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        font-family: Gotham-Book, 'Gotham Book';\n        font-size: 8px;\n      }\n\n      .cls-1, .cls-2 {\n        fill: #231f20;\n      }\n\n      .cls-3 {\n        clip-path: url(#clippath-6);\n      }\n\n      .cls-4 {\n        clip-path: url(#clippath-7);\n      }\n\n      .cls-5 {\n        clip-path: url(#clippath-4);\n      }\n\n      .cls-6 {\n        letter-spacing: 0em;\n      }\n\n      .cls-7 {\n        stroke: #002169;\n        stroke-miterlimit: 10;\n        stroke-width: 0px;\n      }\n\n      .cls-7, .cls-8 {\n        fill: none;\n      }\n\n      .cls-9 {\n        letter-spacing: 0em;\n      }\n\n      .cls-10 {\n        fill: #662f90;\n      }\n\n      .cls-11 {\n        letter-spacing: 0em;\n      }\n\n      .cls-12 {\n        clip-path: url(#clippath-1);\n      }\n\n      .cls-13 {\n        letter-spacing: 0em;\n      }\n\n      .cls-14 {\n        clip-path: url(#clippath-5);\n      }\n\n      .cls-15 {\n        fill: #282561;\n      }\n\n      .cls-16 {\n        fill: #d50057;\n      }\n\n      .cls-17 {\n        fill: #fff;\n        stroke: #231f20;\n        stroke-width: .5px;\n      }\n\n      .cls-18 {\n        clip-path: url(#clippath-3);\n      }\n\n      .cls-19 {\n        letter-spacing: 0em;\n      }\n\n      .cls-20 {\n        letter-spacing: 0em;\n      }\n\n      .cls-21 {\n        letter-spacing: 0em;\n      }\n\n      .cls-22 {\n        fill: #00af9a;\n      }\n\n      .cls-23 {\n        fill: #8ec640;\n      }\n\n      .cls-24 {\n        clip-path: url(#clippath-2);\n      }\n\n      .cls-25 {\n        letter-spacing: 0em;\n      }\n\n      .cls-26 {\n        letter-spacing: 0em;\n      }\n\n      .cls-27 {\n        fill: #3dae2b;\n      }\n\n      .cls-28 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-29 {\n        clip-path: url(#clippath);\n      }\n\n      .cls-30 {\n        letter-spacing: 0em;\n      }\n\n      .cls-31 {\n        fill: #002169;\n      }\n\n      .cls-32 {\n        fill: #c2d500;\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    width: 243,
    height: 153
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-1"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 18,
    y: 18.2,
    width: 64.4,
    height: 29.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-2"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 18,
    y: 19.1,
    width: 62.9,
    height: 26.7
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-3"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 18,
    y: 18.2,
    width: 64.4,
    height: 29.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-4"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 109.8,
    y: 37.6,
    width: 110.2,
    height: 47.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M217.7,44.4c-.4.2-.8.3-1.2.5-.8.4-1.6.8-2.3,1.2-1.5.9-2.9,1.8-4.3,3-2.7,2.2-4.9,5-6.1,8.3-.6,1.6-1,3.3-1.1,5.1,0,.9,0,1.7,0,2.5,0,.8.2,1.7.5,2.6.2.4.4.9.9,1.2.3.1.6.2.8.1.3,0,.5-.2.7-.3.8-.6,1.2-1.3,1.6-2,.8-1.5,1.2-3.1,1.5-4.7-.4,1.6-1,3.2-1.9,4.5-.4.7-1,1.3-1.6,1.7-.2,0-.3.1-.5.2-.1,0-.3,0-.4,0-.2-.1-.4-.5-.5-.8-.2-.7-.2-1.5-.2-2.3,0-.8,0-1.6.2-2.4.2-1.6.7-3.1,1.3-4.5,1.4-2.8,3.6-5.2,6.1-6.9,1.3-.9,2.7-1.7,4.1-2.3.7-.3,1.4-.6,2.2-.9.4-.1.7-.3,1.1-.4.4-.1.8-.2,1.1-.3l-.9-3.3c-.5.2-.9.3-1.3.5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0,
    y1: 153,
    x2: 1,
    y2: 153,
    gradientTransform: "translate(225.2 4472.8) rotate(-180) scale(28.9)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#002169"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#002169"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-6"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 109.8,
    y: 37.6,
    width: 110.2,
    height: 47.4
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath-7"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-8",
    x: 155.2,
    y: 119.3,
    width: 64.4,
    height: 16.4
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1"
  }, /*#__PURE__*/React.createElement("g", {
    className: "cls-29"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-17",
    x: 0.2,
    y: 0.2,
    width: 242.5,
    height: 152.5,
    rx: 11.8,
    ry: 11.8
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M29.8,29.6c-.1,0-.3,0-.4-.2-.6-1-1.5-1.7-2.6-2-.2,0-.3-.3-.3-.5,0-.2.3-.3.5-.3,1.3.4,2.4,1.3,3.1,2.4.1.2,0,.5-.1.6,0,0-.1,0-.2,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M20,33.6c-.2,0-.4-.1-.4-.3-.1-.5-.1-1-.1-1.5,0-1.5.7-3,1.8-4,1.1-1,2.6-1.6,4.1-1.5.2,0,.4.2.4.4,0,.2-.2.4-.4.4-1.3,0-2.6.4-3.5,1.3-1,.9-1.5,2.1-1.6,3.4,0,.4,0,.8.1,1.2,0,.2,0,.5-.3.5,0,0,0,0,0,0"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M25.3,37.8c0,0-.1,0-.2,0-2,0-3.9-1.2-4.9-3-.1-.2,0-.5.2-.6s.5,0,.6.2c.8,1.5,2.4,2.5,4.2,2.6,1.1,0,2.2-.3,3.1-1,.2-.1.4,0,.6,0,.1.2,0,.5,0,.6-1,.7-2.2,1.1-3.4,1.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M22.5,29.7c-.1,0-.2,0-.3-.1-.2-.2-.2-.4,0-.6.5-.6,1.2-1,2-1.2,1.3-.4,2.8,0,3.8.9.2.1.2.4,0,.6-.1.2-.4.2-.6,0-.9-.7-2-1-3.1-.7-.6.2-1.2.5-1.6.9,0,0-.2.1-.3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-10",
    d: "M23.8,35.9c0,0-.1,0-.2,0-1.3-.5-2.2-1.6-2.5-2.9-.2-.8-.2-1.6,0-2.3,0-.2.3-.3.5-.3.2,0,.3.3.3.5-.2.6-.2,1.2,0,1.9.3,1.1,1,1.9,2,2.3.2,0,.3.3.2.5,0,.2-.2.3-.4.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M25.5,36.2c-.2,0-.4-.2-.4-.4,0-.2.2-.4.4-.4.2,0,.5,0,.7-.1.5-.1,1-.4,1.4-.8.2-.2.4-.1.6,0,.2.2.1.4,0,.6-.5.5-1.1.8-1.8,1-.3,0-.6.1-.9.1h0"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-24"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M30.4,28c-.1,0-.2,0-.3-.1-1.1-1.2-2.6-2-4.2-2.2-1.8-.2-3.5.4-4.9,1.6-.2.2-.4.1-.6,0-.2-.2-.1-.4,0-.6,1.5-1.3,3.5-2,5.5-1.8,1.8.2,3.5,1,4.8,2.4.2.2.1.4,0,.6,0,0-.2.1-.3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-23",
    d: "M22.8,38.9c0,0-.1,0-.1,0-3.1-1.2-5-4.2-4.6-7.5.1-1.3.6-2.5,1.3-3.5.1-.2.4-.2.6,0,.2.1.2.4.1.6-.6.9-1,2-1.1,3.1-.3,2.9,1.4,5.6,4.1,6.6.2,0,.3.3.2.5,0,.2-.2.3-.4.3"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-18"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M25.3,39.3c-.2,0-.5,0-.7,0,0,0-.1,0-.2,0-.2,0-.4-.2-.4-.5,0-.2.2-.4.5-.4,0,0,.1,0,.2,0,1.8.2,3.6-.4,4.9-1.6.2-.2.4-.1.6,0,.2.2.1.4,0,.6-1.3,1.2-3.1,1.9-4.8,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M36.3,26h2.6l5.5,12.9h-2.9l-1.2-2.9h-5.4l-1.2,2.9h-2.9l5.5-12.9ZM39.3,33.5l-1.7-4.1-1.7,4.1h3.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M45.3,26.1h5.8c1.6,0,2.9.5,3.7,1.3.7.7,1.1,1.7,1.1,2.9h0c0,2.1-1.1,3.4-2.7,4l3.1,4.6h-3.3l-2.7-4.1h-2.2v4.1h-2.8v-12.8ZM50.9,32.3c1.4,0,2.2-.7,2.2-1.8h0c0-1.2-.8-1.9-2.2-1.9h-2.8v3.7h2.8Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-32",
    points: "57.4 26.1 67 26.1 67 28.6 60.1 28.6 60.1 31.2 66.2 31.2 66.2 33.7 60.1 33.7 60.1 36.4 67.1 36.4 67.1 38.9 57.4 38.9 57.4 26.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-32",
    d: "M67.6,37l1.7-2c1.2.9,2.4,1.6,3.8,1.6s1.8-.5,1.8-1.2h0c0-.7-.4-1.1-2.6-1.7-2.6-.7-4.2-1.4-4.2-3.9h0c0-2.4,1.9-3.9,4.5-3.9s3.4.6,4.7,1.6l-1.5,2.1c-1.1-.8-2.2-1.3-3.3-1.3s-1.6.5-1.6,1.1h0c0,.9.5,1.1,2.8,1.7,2.6.7,4.1,1.6,4.1,3.8h0c0,2.6-1.9,4-4.7,4s-3.9-.7-5.4-2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M28.4,44.3h0c0-.9.7-1.6,1.6-1.6s.9.2,1.2.5l-.2.3c-.3-.2-.6-.4-1-.4-.7,0-1.2.6-1.2,1.3h0c0,.7.5,1.3,1.2,1.3s.7-.2,1-.4l.2.2c-.3.3-.7.5-1.2.5-.9,0-1.6-.7-1.6-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M31.6,44.3h0c0-.9.6-1.6,1.6-1.6s1.6.7,1.6,1.6h0c0,.9-.6,1.6-1.6,1.6s-1.6-.7-1.6-1.6M34.4,44.3h0c0-.7-.5-1.3-1.2-1.3s-1.2.6-1.2,1.3h0c0,.7.5,1.3,1.2,1.3s1.2-.6,1.2-1.3"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 35.3,
    y: 44.3,
    width: 1.2,
    height: 0.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M37.3,42.7h1.2c.7,0,1.2.4,1.2,1h0c0,.7-.6,1-1.2,1h-.8v1.1h-.3v-3.1ZM38.4,44.4c.5,0,.9-.3.9-.7h0c0-.5-.3-.7-.8-.7h-.8v1.4h.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M41.1,42.7h.3l1.4,3.1h-.4l-.4-.8h-1.7l-.4.8h-.4l1.4-3.1ZM42,44.7l-.7-1.6-.7,1.6h1.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "43.9 44.6 42.7 42.7 43.1 42.7 44.1 44.3 45.2 42.7 45.6 42.7 44.3 44.6 44.3 45.8 43.9 45.8 43.9 44.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M47.5,42.7h1.2c.7,0,1.2.4,1.2,1h0c0,.7-.6,1-1.2,1h-.8v1.1h-.3v-3.1ZM48.6,44.4c.5,0,.9-.3.9-.7h0c0-.5-.3-.7-.8-.7h-.8v1.4h.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M50.4,42.7h1.3c.4,0,.7.1.9.3s.2.4.2.6h0c0,.5-.4.8-.8.9l1,1.3h-.4l-.9-1.2h-.9v1.2h-.3v-3.1ZM51.7,44.3c.5,0,.8-.2.8-.6h0c0-.4-.3-.6-.8-.6h-1v1.3h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M53.5,44.3h0c0-.9.6-1.6,1.6-1.6s1.6.7,1.6,1.6h0c0,.9-.6,1.6-1.6,1.6s-1.6-.7-1.6-1.6M56.3,44.3h0c0-.7-.5-1.3-1.2-1.3s-1.2.6-1.2,1.3h0c0,.7.5,1.3,1.2,1.3s1.2-.6,1.2-1.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M57.3,44.3h0c0-.9.6-1.6,1.6-1.6s.8.2,1.2.4l-.2.3c-.2-.2-.5-.4-.9-.4-.7,0-1.2.6-1.2,1.3h0c0,.7.5,1.3,1.2,1.3s.7-.1.9-.3v-.8h-.9v-.3h1.3v1.2c-.3.3-.7.5-1.2.5-1,0-1.6-.7-1.6-1.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M60.9,42.7h1.3c.4,0,.7.1.9.3s.2.4.2.6h0c0,.5-.4.8-.8.9l1,1.3h-.4l-.9-1.2h-.9v1.2h-.3v-3.1ZM62.2,44.3c.5,0,.8-.2.8-.6h0c0-.4-.3-.6-.8-.6h-1v1.3h1Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M65.2,42.7h.3l1.4,3.1h-.4l-.4-.8h-1.7l-.4.8h-.4l1.4-3.1ZM66.1,44.7l-.7-1.6-.7,1.6h1.4Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "67.6 42.7 68 42.7 69.1 44.4 70.2 42.7 70.6 42.7 70.6 45.8 70.2 45.8 70.2 43.3 69.1 45 69.1 45 67.9 43.3 67.9 45.8 67.6 45.8 67.6 42.7"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "38.1 19.3 41.3 19.3 41.3 20.2 39.6 20.2 39.6 20.9 41.2 20.9 41.2 21.8 39.6 21.8 39.6 22.6 41.3 22.6 41.3 23.5 38.1 23.5 38.1 19.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "42.1 19.3 43.6 19.3 43.6 22.5 45.3 22.5 45.3 23.5 42.1 23.5 42.1 19.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "45.7 19.3 47.2 19.3 47.2 22.5 48.9 22.5 48.9 23.5 45.7 23.5 45.7 19.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "52.2 19.2 48.7 19.2 48.7 19.6 50.3 19.6 50.3 23.6 50.6 23.6 50.6 19.6 52.2 19.6 52.2 19.2 52.2 19.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M55.1,22c-.2-.3-.4-.5-.6-.6.5-.2.8-.6.8-1s-.1-1.1-1.4-1.1h-1.1v4.3h.4v-2h.6c.5,0,.7,0,1.2.9l.7,1.2h.4s0,0,0,0l-1-1.5ZM53.2,19.6h.7c.7,0,1.1.3,1.1.8s-.4.8-1.1.8h-.7v-1.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "56.9 19.2 56.5 19.2 56.5 23.6 56.9 23.6 56.9 19.2 56.9 19.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M59.7,19.2c-1.3,0-2.3,1-2.3,2.2s1,2.2,2.3,2.2,2.3-1,2.3-2.2-1-2.2-2.3-2.2M59.7,23.3c-1.1,0-1.9-.8-1.9-1.9s.8-1.9,1.9-1.9,1.9.8,1.9,1.9-.8,1.9-1.9,1.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M66.4,19.2h-.4v3.7c0,0-3.2-3.7-3.2-3.7h-.3s0,0,0,0v4.3h.4v-3.7c0,0,3.2,3.7,3.2,3.7h.3s0,0,0,0v-4.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M35.2,22.3c-.5,0-.9-.4-.9-.9s.4-.9.9-.9.6.2.8.4h1.5c-.2-1-1.2-1.8-2.3-1.8s-2.3,1-2.3,2.3,1,2.3,2.3,2.3,2.1-.9,2.3-2h-1.4c-.1.3-.5.6-.9.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "77.7 26.9 79.1 26.9 79.1 27.1 78.5 27.1 78.5 28.6 78.3 28.6 78.3 27.1 77.7 27.1 77.7 26.9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.7,28.6v-1s0-.3,0-.4h0l-.5,1.4h-.2l-.5-1.4h0c0,.2,0,.4,0,.4v1h-.2v-1.7h.3l.5,1.4h0l.5-1.4h.3v1.7h-.2Z"
  })), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(18 119.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ID:")), /*#__PURE__*/React.createElement("g", {
    className: "cls-5"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M185.2,41.4c.5,0,1.1.3,1.7.4.6.2,1.2.3,1.7.5,1.2.4,2.3.8,3.4,1.4,2.3,1.1,4.5,2.4,6.5,4,.5.4,1,.8,1.5,1.3.5.5,1,.9,1.5,1.4.5.5.9,1,1.4,1.5.4.5.8,1.1,1.2,1.8,1.4,2.5,2.2,5.8,2.4,9,0-3.3-.5-6.6-1.8-9.6-.3-.7-.7-1.4-1.1-2.1-.4-.6-.9-1.2-1.3-1.8-.5-.6-.9-1.1-1.4-1.7-.5-.5-1-1-1.5-1.6-2-2-4.2-3.7-6.5-5.1-1.1-.7-2.3-1.3-3.5-1.9-.6-.3-1.2-.6-1.8-.8-.6-.2-1.2-.5-1.9-.7l-.5,3.8Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-14"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-28",
    x: 197.3,
    y: 45.3,
    width: 28.2,
    height: 22.3,
    transform: "translate(109.5 250.1) rotate(-77.2)"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-3"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-16",
    d: "M202.8,45.1c0,1.4,1.1,2.5,2.5,2.5s2.5-1.1,2.5-2.5-1.1-2.5-2.5-2.5-2.5,1.1-2.5,2.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M123.7,49.4l-3.5,8c-.5,1.1-.9,1.5-1.5,1.8v6.4c0,.3-.2.5-.5.5h-3c-.3,0-.5-.2-.5-.5v-6.4c-.6-.2-1.1-.7-1.5-1.8l-3.5-8s0-.1,0-.2c0-.2.1-.3.4-.3h3.3c.2,0,.4.2.5.4l2.5,6.5c.1.3.2.3.3.3s.2,0,.3-.3l2.5-6.5c0-.2.2-.4.5-.4h3.3c.2,0,.4.2.4.3s0,.1,0,.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M134.9,66h-2.6c-.3,0-.5-.2-.5-.5v-.6c-1.3.9-2.3,1.2-3.8,1.2-3.3,0-4.1-2.3-4.1-5.2v-7.7c0-.3.2-.5.5-.5h2.8c.3,0,.5.2.5.5v7.7c0,1.6.3,2.1,1.7,2.1s1.4-.3,2.2-.7v-9.1c0-.3.2-.5.5-.5h2.8c.3,0,.5.2.5.5v12.3c0,.3-.2.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M151,48.3s-2,0-2.9,0c-.2,0-.4.2-.4.4v16.8c0,.3.2.5.5.5h2.8c.3,0,.5-.2.5-.5v-16.7c0-.2-.2-.5-.4-.5M139.7,51.8v1h-1.8c-.3,0-.5.2-.5.5v1.4c0,.3.2.5.5.6l1.8.3v10c0,.3.2.5.5.5h2.8c.3,0,.5-.2.5-.5v-10h1.9c.2,0,.5-.2.5-.5v-1.9c0-.3-.2-.5-.5-.5h-1.9v-.8c0-.9,0-1.1,1.2-1.1h.6c.3,0,.6-.3.6-.6v-1.6c0-.3-.3-.6-.6-.6-.4,0-.8,0-1.1,0-3,0-4.4.4-4.4,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M166,53.3l-3.9,13.6c-.7,2.5-1.7,3.8-5,3.8s-2.2-.2-2.8-.4c-.3,0-.5-.2-.5-.4v-1.9c0-.3.2-.4.5-.4h0c.8,0,2.1.2,2.9.2s1.2-.3,1.5-1.2l.2-.7h-.3c-.9,0-1.6-.1-2.1-2.1l-3-10.4c0,0,0-.1,0-.2,0-.2.1-.4.5-.4h3.1c.2,0,.4.2.4.4l2.1,8.7c0,.3.1.4.3.4h.2l2.1-9.1c0-.2.2-.4.5-.4h3.1c.2,0,.4.2.4.4s0,0,0,.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M184.8,66h-2.8c-.3,0-.5-.2-.5-.5v-7.9c0-1.5-.3-1.9-1.4-1.9s-1.1,0-1.8.4c0,.5,0,1,0,1.5v7.9c0,.3-.2.5-.5.5h-2.8c-.3,0-.5-.2-.5-.5v-7.9c0-1.5-.3-1.9-1.3-1.9s-1,.2-1.8.6v9.2c0,.3-.2.5-.5.5h-2.8c-.3,0-.5-.2-.5-.5v-12.3c0-.3.2-.5.5-.5h2.6c.3,0,.5.2.5.5v.5c1-.6,2.1-1.2,3.4-1.2s2.1.3,2.7,1.1c1.3-.8,2.3-1.1,3.8-1.1,3,0,4,2,4,5v7.9c0,.3-.2.5-.5.5"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M197.8,66h-2.6c-.3,0-.5-.2-.5-.5v-.4c-.9.6-1.8,1-3.2,1-2,0-3.9-1-3.9-4v-.2c0-2.7,1.7-3.9,5.7-3.9h1.2v-.8c0-1.3-.6-1.6-1.7-1.6s-3.1,0-3.8.2h-.1c-.2,0-.4-.1-.4-.4v-1.9c0-.3.2-.4.4-.5.9-.2,2.5-.5,4-.5,3.3,0,5.4,1.3,5.4,4.7v8.2c0,.3-.2.5-.5.5M194.6,60.3h-1.3c-1.6,0-2,.6-2,1.7v.2c0,1,.5,1.2,1.5,1.2s1.3-.2,1.9-.5v-2.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M118.7,80c0,.6,0,1.2,0,1.7h-1.1v-.8h-.1c-.3.6-.9.9-1.5.9-1,0-1.8-.8-1.8-2.2,0-1.9,1.5-2.7,3.2-2.7v-.2c0-1-.2-1.7-1.2-1.7s-.9.1-1.2.4l-.3-.8c.3-.2,1-.5,1.8-.5,1.5,0,2.2,1,2.2,2.7v3.3ZM117.6,77.8c-.6,0-2.1.1-2.1,1.8s.5,1.3.9,1.3,1-.4,1.1-1.1c0-.1,0-.3,0-.4v-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M124.9,70.9v9c0,.5,0,1.4,0,1.8h-1v-.9h-.1c-.2.5-.8,1.1-1.6,1.1-1.3,0-2.2-1.4-2.2-3.9s1.1-3.9,2.3-3.9,1.1.2,1.4.9h0v-4h1.2ZM123.7,77c0-.2,0-.3,0-.5,0-.8-.5-1.5-1.1-1.5-1,0-1.3,1.4-1.3,2.9s.4,2.9,1.3,2.9.9-.2,1.2-1.3c0-.1,0-.3,0-.5v-2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M130.4,80c0,.6,0,1.2,0,1.7h-1.1v-.8h-.1c-.3.6-.9.9-1.5.9-1,0-1.8-.8-1.8-2.2,0-1.9,1.5-2.7,3.2-2.7v-.2c0-1-.2-1.7-1.2-1.7s-.9.1-1.2.4l-.3-.8c.3-.2,1-.5,1.8-.5,1.5,0,2.2,1,2.2,2.7v3.3ZM129.2,77.8c-.6,0-2.1.1-2.1,1.8s.5,1.3.9,1.3,1-.4,1.1-1.1c0-.1,0-.3,0-.4v-1.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 132,
    y: 70.9,
    width: 1.2,
    height: 10.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M135.4,73c-.4,0-.7-.3-.7-.8s.3-.8.7-.8.7.3.7.8-.3.8-.7.8h0ZM134.9,74.2h1.2v7.5h-1.2v-7.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M137.6,76.1c0-.9,0-1.3,0-1.9h1.1v.9h0c.3-.6.9-1,1.7-1s1.3.3,1.6,1.1h0c.2-.4.5-.7.7-.9.3-.2.7-.3,1-.3,1,0,1.8.7,1.8,2.7v5h-1.2v-4.7c0-1-.1-1.9-1-1.9s-.9.4-1.1,1.1c0,.2,0,.4,0,.7v4.9h-1.2v-5c0-.8-.1-1.7-1-1.7s-1,.4-1.1,1.2c0,.2,0,.4,0,.6v4.8h-1.2v-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M151.7,79.6c0,.8,0,1.5,0,2.1h-1v-.8h-.1c-.2.4-.8.9-1.6.9-1.3,0-1.8-1-1.8-2.9v-4.8h1.2v4.6c0,1.2.2,2.1,1,2.1s1-.7,1.1-1c0-.2,0-.4,0-.7v-5h1.2v5.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M153.3,76.1c0-.9,0-1.3,0-1.9h1.1v.9h0c.3-.6.9-1,1.7-1s1.3.3,1.6,1.1h0c.2-.4.5-.7.7-.9.3-.2.7-.3,1-.3,1,0,1.8.7,1.8,2.7v5h-1.2v-4.7c0-1-.1-1.9-1-1.9s-.9.4-1.1,1.1c0,.2,0,.4,0,.7v4.9h-1.2v-5c0-.8-.1-1.7-1-1.7s-1,.4-1.1,1.2c0,.2,0,.4,0,.6v4.8h-1.2v-5.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M166.8,80c0,.6,0,1.2,0,1.7h-1.1v-.8h-.1c-.3.6-.9.9-1.5.9-1,0-1.8-.8-1.8-2.2,0-1.9,1.5-2.7,3.2-2.7v-.2c0-1-.2-1.7-1.2-1.7s-.9.1-1.2.4l-.3-.8c.3-.2,1-.5,1.8-.5,1.5,0,2.1,1,2.1,2.7v3.3ZM165.6,77.8c-.6,0-2.1.1-2.1,1.8s.5,1.3.9,1.3,1-.4,1.1-1.1c0-.1,0-.3,0-.4v-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M168.4,70.9h1.2v4.1h0c.4-.7,1-1,1.6-1,1.2,0,2.1,1.3,2.1,3.8s-1.1,4-2.3,4-1.2-.5-1.5-1.1h0v1h-1.1c0-.4,0-1.3,0-1.8v-9ZM169.6,79c0,.2,0,.3,0,.5.3,1.1.8,1.3,1.1,1.3,1,0,1.3-1.3,1.3-2.9s-.4-2.9-1.3-2.9-1,.7-1.1,1.3c0,.2,0,.4,0,.5v2.1Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-22",
    x: 174.3,
    y: 77.2,
    width: 3.4,
    height: 0.9
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M182.9,80c0,.6,0,1.2,0,1.7h-1.1v-.8h-.1c-.3.6-.9.9-1.5.9-1,0-1.8-.8-1.8-2.2,0-1.9,1.5-2.7,3.2-2.7v-.2c0-1-.2-1.7-1.2-1.7s-.9.1-1.2.4l-.3-.8c.3-.2,1-.5,1.8-.5,1.5,0,2.2,1,2.2,2.7v3.3ZM181.8,77.8c-.6,0-2.1.1-2.1,1.8s.5,1.3.9,1.3,1-.4,1.1-1.1c0-.1,0-.3,0-.4v-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M188.5,80c0,.6,0,1.2,0,1.7h-1.1v-.8h-.1c-.3.6-.9.9-1.5.9-1,0-1.8-.8-1.8-2.2,0-1.9,1.5-2.7,3.2-2.7v-.2c0-1-.2-1.7-1.2-1.7s-.9.1-1.2.4l-.3-.8c.3-.2,1-.5,1.8-.5,1.5,0,2.2,1,2.2,2.7v3.3ZM187.3,77.8c-.6,0-2.1.1-2.1,1.8s.5,1.3.9,1.3,1-.4,1.1-1.1c0-.1,0-.3,0-.4v-1.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M191.4,72.4v1.8h1.4v.9h-1.4v4.5c0,1,.3,1.2.8,1.2s.4,0,.5,0v.9c-.2,0-.4.1-.8.1s-.9-.1-1.2-.5c-.3-.3-.5-.9-.5-1.9v-4.4h-.9v-.9h.9v-1.3l1.2-.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-22",
    d: "M194.6,74.2l1,4.3c.1.6.2,1.1.3,1.6h0c0-.4.2-1,.3-1.5l.9-4.3h1.2l-1.2,4.8c-.5,1.9-1,3.7-1.9,4.9-.5.7-1.1,1-1.4,1.1l-.4-1c.3-.2.7-.5,1.1-1,.3-.4.6-.9.7-1.3,0-.2,0-.3,0-.4s0-.2,0-.3l-1.9-6.9h1.3Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-31",
    d: "M199.9,51.1c.9,0,1.6.7,1.6,1.6s-.7,1.6-1.6,1.6-1.6-.7-1.6-1.6.7-1.6,1.6-1.6h0ZM199.9,51.5c-.7,0-1.2.6-1.2,1.2s.5,1.2,1.2,1.2c.7,0,1.2-.6,1.2-1.2s-.5-1.3-1.2-1.3h0ZM199.7,53.5h-.4v-1.6c.1,0,.3,0,.6,0s.4,0,.5.1c0,0,.2.2.2.3s-.1.3-.3.4h0c.2,0,.2.2.3.4,0,.2,0,.3.1.4h-.4c0,0,0-.2-.1-.4,0-.2-.1-.2-.3-.2h-.2v.6ZM199.7,52.6h.2c.2,0,.4,0,.4-.2s-.1-.2-.3-.2-.2,0-.2,0v.4Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M199.9,51.1c.9,0,1.6.7,1.6,1.6s-.7,1.6-1.6,1.6-1.6-.7-1.6-1.6.7-1.6,1.6-1.6h0ZM199.9,51.5c-.7,0-1.2.6-1.2,1.2s.5,1.2,1.2,1.2c.7,0,1.2-.6,1.2-1.2s-.5-1.3-1.2-1.3h0ZM199.7,53.5h-.4v-1.6c.1,0,.3,0,.6,0s.4,0,.5.1c0,0,.2.2.2.3s-.1.3-.3.4h0c.2,0,.2.2.3.4,0,.2,0,.3.1.4h-.4c0,0,0-.2-.1-.4,0-.2-.1-.2-.3-.2h-.2v.6ZM199.7,52.6h.2c.2,0,.4,0,.4-.2s-.1-.2-.3-.2-.2,0-.2,0v.4Z"
  })), /*#__PURE__*/React.createElement("g", {
    className: "cls-4"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M191.5,125.4h0c-.1,0-.3,0-.4,0-.1,0-.3,0-.4,0s-.4,0-.6,0c-.2,0-.4-.1-.5-.3-.2-.1-.3-.3-.4-.5,0-.2-.1-.4-.1-.7s0-.5.1-.6c0-.2.2-.3.3-.5.1-.1.3-.2.5-.3.2,0,.4,0,.6,0s.5,0,.8.1v.6c-.3-.1-.5-.2-.8-.2s-.3,0-.4,0c-.1,0-.2.1-.3.2,0,0-.1.2-.2.3,0,.1,0,.2,0,.4,0,.3,0,.5.3.7.2.2.4.2.7.2s.2,0,.4,0c.1,0,.2,0,.4-.1v.6Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "191.8 122.6 193.8 122.6 193.8 123.2 192.5 123.2 192.5 123.8 193.7 123.8 193.7 124.3 192.5 124.3 192.5 124.9 193.8 124.9 193.8 125.5 191.8 125.5 191.8 122.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "194.2 122.6 195 122.6 195 124.9 196.1 124.9 196.1 125.5 194.2 125.5 194.2 122.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "196.4 122.6 197.1 122.6 197.1 124.9 198.3 124.9 198.3 125.5 196.4 125.5 196.4 122.6"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "198.6 123.2 197.9 123.2 197.9 122.6 200 122.6 200 123.2 199.3 123.2 199.3 125.5 198.6 125.5 198.6 123.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.3,122.6h1.3c.3,0,.5,0,.7.2.2.1.3.3.3.5,0,.4-.2.6-.5.7h0c0,0,.1,0,.2.1,0,0,0,.2.1.3,0,0,0,.2,0,.2l.3.8h-.8l-.2-.5c0-.1,0-.2-.1-.3,0,0,0-.1-.1-.2,0,0,0,0-.1,0,0,0-.1,0-.2,0h-.2v1.1h-.8v-2.8ZM201,123.8h.2c0,0,.1,0,.2,0,0,0,.1,0,.2,0,0,0,0,0,.1,0,0,0,0-.1,0-.2s0-.1,0-.2c0,0,0,0-.1,0,0,0-.2,0-.4,0h-.2v.6Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 202.9,
    y: 122.6,
    width: 0.8,
    height: 2.8
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M204.4,123c.2-.3.6-.4,1.1-.4s.8.1,1.1.4c.2.3.4.6.4,1.1s-.1.8-.4,1.1c-.2.3-.6.4-1.1.4s-.8-.1-1.1-.4-.4-.6-.4-1.1.1-.8.4-1.1M204.9,124.4c0,.1,0,.2.1.3,0,0,.1.1.2.2,0,0,.2,0,.3,0s.2,0,.3,0c0,0,.1-.1.2-.2,0,0,0-.2.1-.3,0-.1,0-.2,0-.3s0-.2,0-.4c0-.1,0-.2-.1-.3,0,0-.1-.1-.2-.2,0,0-.2,0-.3,0s-.2,0-.3,0c0,0-.1.1-.2.2,0,0,0,.2-.1.3,0,.1,0,.2,0,.4s0,.2,0,.3"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "207.3 122.6 208.2 122.6 209.2 124.6 209.2 124.6 209.2 122.6 209.9 122.6 209.9 125.5 208.9 125.5 207.9 123.5 207.9 123.5 208 125.5 207.3 125.5 207.3 122.6"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M213.9,124.4c0,.4-.1.7-.3.8-.2.2-.5.3-.9.3s-.7,0-.9-.3c-.2-.2-.3-.5-.3-.8v-1.8h.8v1.6c0,.1,0,.2,0,.3,0,0,0,.2,0,.2,0,0,0,.1.2.1,0,0,.1,0,.2,0s.2,0,.2,0c0,0,.1,0,.2-.1,0,0,0-.1,0-.2,0,0,0-.2,0-.3v-1.6h.8v1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M214.4,124.8c.1,0,.2.1.4.1.1,0,.3,0,.4,0s.3,0,.3,0c0,0,.1-.1.1-.2s0-.2-.1-.2c0,0-.2-.1-.4-.2-.1,0-.2,0-.3-.1,0,0-.2,0-.2-.1,0,0-.1-.1-.2-.2,0,0,0-.2,0-.4s0-.3.1-.4c0-.1.2-.2.3-.3.1,0,.2-.1.4-.1.1,0,.3,0,.4,0s.3,0,.4,0c.1,0,.2,0,.3,0v.6c-.2,0-.4-.1-.7-.1s-.1,0-.2,0c0,0-.1,0-.2,0,0,0,0,0-.1,0,0,0,0,0,0,.1s0,.1.1.2c0,0,.2,0,.4.1.1,0,.2,0,.3.1,0,0,.2,0,.3.1,0,0,.1.1.2.2,0,0,0,.2,0,.4s0,.3-.1.4c0,.1-.2.2-.3.3-.1,0-.2.1-.4.2-.1,0-.3,0-.5,0s-.3,0-.4,0c-.2,0-.3,0-.4,0v-.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M217.6,122.6h.9l1.1,2.8h-.8l-.2-.6h-1.1l-.2.6h-.8l1.1-2.8ZM218,123.2h0l-.4,1.1h.7l-.3-1.1Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "172.8 128.4 178 128.4 178 129.9 175.2 129.9 175.2 131.1 177.8 131.1 177.8 132.6 175.2 132.6 175.2 133.9 178.1 133.9 178.1 135.4 172.8 135.4 172.8 128.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "179.3 128.4 181.8 128.4 181.8 133.6 184.6 133.6 184.6 135.4 179.3 135.4 179.3 128.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "185.4 128.4 187.8 128.4 187.8 133.6 190.6 133.6 190.6 135.4 185.4 135.4 185.4 128.4"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "196.1 128.3 190.2 128.3 190.2 128.9 192.8 128.9 192.8 135.4 193.4 135.4 193.4 128.9 196.1 128.9 196.1 128.3 196.1 128.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M200.8,133c-.3-.5-.6-.9-.9-1,.9-.3,1.3-.9,1.3-1.7s-.2-1.9-2.4-1.9h-1.8v7.1h.6v-3.4h.9c.8,0,1.1.1,1.9,1.4l1.2,1.9h.7s0,0,0,0l-1.6-2.5ZM197.6,128.9h1.1c1.2,0,1.8.5,1.8,1.3s-.6,1.4-1.8,1.4h-1.1v-2.7Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "cls-2",
    points: "203.8 128.3 203.2 128.3 203.2 135.4 203.8 135.4 203.8 128.3 203.8 128.3"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M208.4,128.2c-2.1,0-3.8,1.6-3.8,3.7s1.7,3.7,3.8,3.7,3.8-1.6,3.8-3.7-1.7-3.7-3.8-3.7M208.4,135c-1.7,0-3.1-1.3-3.1-3.1s1.4-3.1,3.1-3.1,3.1,1.4,3.1,3.1-1.4,3.1-3.1,3.1"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M219.5,128.3h-.6v6.1c-.1-.1-5.3-6.1-5.3-6.1h-.5s0,0,0,0v7.1h.6v-6.1c.1.1,5.3,6.1,5.3,6.1h.5s0,0,0,0v-7.1h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M167.9,133.5c-.8,0-1.5-.7-1.5-1.5s.7-1.5,1.5-1.5,1,.3,1.3.7h2.5c-.4-1.7-1.9-3-3.7-3s-3.8,1.7-3.8,3.8,1.7,3.8,3.8,3.8,3.5-1.4,3.8-3.2h-2.4c-.2.6-.8.9-1.4.9"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M167.8,119.3c-2.1,0-3.7,1.7-3.7,3.7s1.7,3.8,3.7,3.8,3.7-1.7,3.7-3.8-1.7-3.7-3.7-3.7M167.8,125.2c-1.2,0-2.2-1-2.2-2.2s1-2.2,2.2-2.2,2.2,1,2.2,2.2-1,2.2-2.2,2.2"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M155.2,131.9c0,2.1,1.7,3.7,3.7,3.7s3.7-1.7,3.7-3.7-1.7-3.7-3.7-3.7-3.7,1.7-3.7,3.7"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-27",
    d: "M159,119.3c-2.1,0-3.7,1.7-3.7,3.7s1.7,3.7,3.7,3.7,3.7-1.7,3.7-3.7-1.7-3.7-3.7-3.7M159,126.2c-1.7,0-3.2-1.4-3.2-3.2s1.4-3.2,3.2-3.2,3.2,1.4,3.2,3.2-1.4,3.2-3.2,3.2"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(18 71.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RxBIN:")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(52.8 71.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-30",
    x: 0,
    y: 0
  }, "6"), /*#__PURE__*/React.createElement("tspan", {
    x: 5,
    y: 0
  }, "10"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 13.6,
    y: 0
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 18.4,
    y: 0
  }, "2"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-25",
    x: 23,
    y: 0
  }, "4"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(18 83.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RxPCN:")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(52.8 83.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 0,
    y: 0
  }, "L"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 4.9,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 9.8,
    y: 0
  }, "y"), /*#__PURE__*/React.createElement("tspan", {
    x: 14.3,
    y: 0
  }, "alty"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(18 95.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "RxGRP:")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(52.8 95.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "5"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 4.9,
    y: 0
  }, "0"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 10.4,
    y: 0
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-26",
    x: 15.2,
    y: 0
  }, "7"), /*#__PURE__*/React.createElement("tspan", {
    x: 19.8,
    y: 0
  }, "8109"))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(18 107.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "I"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 2.3,
    y: 0
  }, "S"), /*#__PURE__*/React.createElement("tspan", {
    x: 7.4,
    y: 0
  }, "SUER:")), /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(52.8 107.5)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "(80840)"))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCardYuflyma);
export default __webpack_public_path__ + "static/media/card-yuflyma.7669bed6b6b687033e18d5549c2f71c2.svg";
export { ForwardRef as ReactComponent };